/*
*
* File JS componente Block Wines
*
*/

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import 'swiper/css/bundle';
import Swiper from 'swiper/bundle';

import './block-wines.scss';

//--------------------------------------------------------------------//

import cardWine from 'components/card-wine/card-wine';
import modal from '../../im-components/modal/modal';

// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const blockWines = () => {
    
    //SWIPER IN MOBILE
    let allBlockWineSliders = document.querySelectorAll('.block-wines-slider');
    
    allBlockWineSliders.forEach(el => {
        if (!allBlockWineSliders.length) return;

        let args = {
            slidesPerView: "auto",
            spaceBetween: 30,
            centeredSlides: true,
        };

        new Swiper(el.querySelector('.swiper'), args);

    });
    

    //APERTURA E CHIUSURA SCHEDE VINO 
    let cardsWine = document.querySelectorAll('.card-wine');
    let btnCloseModal = document.querySelector('.wine-modal__close');
    let modalWine  = document.querySelector('.wine-modal');;

    if ( !modalWine ) return;

    const openModal = () => { 
        modalWine.classList.add('open'); 
    }

    const closeModal = () => {
        modalWine.classList.remove('open');
    }

    cardsWine.forEach( card => {
        card.addEventListener('click', (event) => {
            const cardId = event.currentTarget.getAttribute('data-wine');
            getDataCard(cardId);
            openModal();
        })
    })

    btnCloseModal.addEventListener('click', () => {
        closeModal();
    })

    const closeAllOnKeyup = (e) => {
        if(e.keyCode === 27)
        {
            document.body.style.overflow = '';
            closeModal();
        }
    }

    document.addEventListener('keyup', closeAllOnKeyup);

    //Funzione per recuperare i dati dalle card e iniettarli nella modale
    const getDataCard = (id) => {
        //NOME
        const nome = document.querySelector(`#nome-${id}`);
        const nomeModal = modalWine.querySelector('.nome');
        nomeModal.innerHTML = nome.innerHTML;
        //COMPOSIZIONE
        const composizione = document.querySelector(`#composizione-${id}`);
        const composizioneModal = modalWine.querySelector('.composizione');
        composizioneModal.innerHTML = composizione.innerHTML;
        //DESCRIZIONE
        const descrizione = document.querySelector(`#descrizione-${id}`);
        const descrizioneModal = modalWine.querySelector('.descrizione');
        descrizioneModal.innerHTML = descrizione.innerHTML;
        //PRODUZIONE
        const produzione = document.querySelector(`#produzione-${id}`);
        const produzioneModal = modalWine.querySelector('.produzione');
        produzioneModal.innerHTML = produzione.innerHTML;
        //ALTITUDINE
        const altitudine = document.querySelector(`#altitudine-${id}`);
        const altitudineModal = modalWine.querySelector('.altitudine');
        altitudineModal.innerHTML = altitudine.innerHTML;
        //TERRENO
        const terreno = document.querySelector(`#terreno-${id}`);
        const terrenoModal = modalWine.querySelector('.terreno');
        terrenoModal.innerHTML = terreno.innerHTML;
        //ALLEVAMENTO
        const allevamento = document.querySelector(`#allevamento-${id}`);
        const allevamentoModal = modalWine.querySelector('.allevamento');
        allevamentoModal.innerHTML = allevamento.innerHTML;
        //NOTE
        const note = document.querySelector(`#note-${id}`);
        const noteModal = modalWine.querySelector('.note');
        noteModal.innerHTML = note.innerHTML;
        //IMMAGINE
        const img = document.querySelector(`#img-${id}`);
        const imgModal = modalWine.querySelector('.img');
        imgModal.innerHTML = img.innerHTML;
        //CATALOGO
        const catalogo = document.querySelector(`#catalogo-${id}`);
        if(!catalogo) return;
        const catalogoModal = modalWine.querySelector('.catalogo');
        const linkCatalogo = catalogoModal.setAttribute('href', catalogo.innerHTML);
    }

}

export default blockWines;

//--------------------------------------------------------------------//